import React, { useEffect, useState } from 'react';
import ConfirmField from './ConfirmField';

const OtherInfoTextField = ({
  language,
  isConfirm,
  placeholder,
  defaultValue,
  isNumeral,
  fieldName,
  editAction,
}) => {
  const [inputValue, setInputValue] = useState(defaultValue);

  useEffect(() => {
    setInputValue(defaultValue);
  }, [defaultValue]);

  const onEdit = (value) => {
    editAction(fieldName, value);
  };

  if (isConfirm) {
    return (
      <ConfirmField value={defaultValue} />
    )
  };

  return (
    <div>
      <input
        className="account-input-with-downarrow field-text"
        {...(isNumeral ? {
          type: "number",
          inputMode: "numeric"
        } : {})}
        value={inputValue}
        placeholder={placeholder}
        onChange={(e) => {
          const text = e.target.value;
          onEdit(text);
        }}
      />
    </div>
  );
};

export default OtherInfoTextField;
